<template>
  <div>
    <v-select
      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
      taggable
      :placeholder="T('Web.Generic.Choose')"
      :options="transportvehicles"
      label="name"
      v-model="content"
      :reduce="(transportvehicles) => transportvehicles.id"
      @option:selected="handleInput"
    />
  </div>
</template>

<script>
import vSelect from "vue-select";
import { mapGetters, mapActions } from "vuex";

export default {
  props: {
    value: { required: true },
    selectedId: { required: false },
  },
  components: {
    vSelect,
  },
  created() {},
  data() {
    return {
      content: this.value,
    };
  },
  async mounted() {
    await this.fetch();
  },
  computed: {
    ...mapGetters({ transportvehicles: "transportvehicle/list" }),
  },
  methods: {
    ...mapActions({ fetch: "transportvehicle/fetchList" }),
    handleInput() {
      this.$emit("input", this.content);
    },
    setContent(value) {
      this.content = value;
    },
  },
  watch: {
    transportvehicles(newValue, oldValue) {
      if (this.selectedId == undefined) return;
      let elm = this.transportvehicles.find((e) => e.id == this.selectedId);
      if (elm == undefined) return;

      this.setContent(elm);
    },
    content(newValue, oldValue) {
      if (newValue != oldValue) this.handleInput();
    },
  },
};
</script>